module.exports = __webpack_public_path__ + "img/fvs.9e050e20.png";